type Props = {
  size?: number;
};

export const Notification = ({ size = 8 }: Props) => (
  <span
    style={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%',
      border: '0.5px solid #FFFFFF',
      background: '#8E6DFF',
    }}
  />
);
